import { InputContainer } from 'styles'
import { ChangeEvent, useState, useEffect, useRef } from 'react'
import { inputIcons } from 'helper'
import { IInputIcons } from 'helper/inputIcon'
import { useField } from '@unform/core'
import { Input, InputIcon, InputError } from './style'

interface IInputProps {
  name: string
  type: string
  rounded?: boolean
  icon?: keyof IInputIcons
  placeholder?: string
  disabled?: boolean
  value?: string
  small?: boolean
  xsmall?: boolean
  large?: boolean
  marginRight?: number
  smallPad?: boolean
  onChange?: (_e: ChangeEvent<HTMLInputElement>) => void
  initialError?: string
  className?: string
  id?: string
}

export default function InputComponent({
  icon,
  type,
  name,
  initialError,
  ...rest
}: IInputProps) {
  const [iconState, setIconState] = useState(0)
  const { fieldName, registerField, defaultValue, error } = useField(name)
  const inputRef = useRef(null)
  const [Erro, setErro] = useState(initialError)

  const handleChangeState = () => {
    setIconState((oldState) => {
      if (oldState === 0) return 1
      return 0
    })
  }

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    })
  }, [registerField, fieldName])

  useEffect(() => {
    if (error) {
      setErro(error)
    }
  }, [error])

  return (
    <InputContainer>
      <Input
        ref={inputRef}
        {...rest}
        error={Erro}
        type={
          type === 'password' ? (iconState === 0 ? 'password' : 'text') : type
        }
        defaultValue={defaultValue}
      />
      {icon && (
        <InputIcon
          icon={icon}
          src={inputIcons[icon][iconState]}
          alt="input icon"
          onClick={handleChangeState}
        />
      )}
      {Erro && <InputError>{Erro}</InputError>}
    </InputContainer>
  )
}
